import Vue from 'vue';
import translation from '@/assets/rawData/i18n/bonusesPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
import BigNumber from 'bignumber.js';
import BonusAccrualAccordion from './../components/pages/bonus/components/widgets/bonusAccrualWidget/components/bonusAccrualAccordion/index.vue';
export default Vue.extend({
    name: 'bonusAccrualPage',
    data: () => {
        return {
            scaleInfo: {
                25: ['0', '2000'],
                26: ['2000', '5000'],
                27: ['5000', '10000'],
                28: ['10000', '15000'],
                29: ['15000', '30000'],
                30: ['30000', '9999999999']
            },
            isIndividual: true,
            deniedReasons: []
        };
    },
    created() {
        applyPageI18NMessages(this, 'bonusesPage', translation);
        const { scale, isIndividual, deniedReasons } = this.$route.query;
        if (!scale || !isIndividual)
            return;
        this.scaleInfo = JSON.parse(scale);
        this.deniedReasons = JSON.parse(deniedReasons);
        this.isIndividual = JSON.parse(isIndividual) === 'yes';
    },
    computed: {
        percentInfo() {
            const sortedArray = Object.entries(this.scaleInfo)
                .sort((a, b) => {
                const rootKeyA = parseInt(a[0]);
                const rootKeyB = parseInt(b[0]);
                return rootKeyA - rootKeyB;
            });
            return sortedArray.reduce((acc, value) => {
                const valFrom = BigNumber(value[1][0]);
                const valTo = BigNumber(value[1][1]);
                const formatType = { decimalSeparator: ',', groupSeparator: ' ', groupSize: 3 };
                const from = valFrom.isGreaterThan(0) ? `${this.$t('bonusesPage.widgets.upTo').toLowerCase()} ${valFrom.toFormat(formatType)}` : '';
                const to = valTo.isGreaterThan(0) ? `${this.$t('bonusesPage.widgets.to').toLowerCase()} ${valTo.toFormat(formatType)}` : '';
                const isLast = valTo.eq('9999999999');
                const obj = {
                    percent: `${value[0]}%`,
                    val: `${from} ${!isLast ? to : ''} USDT ${!isLast ? this.$t('bonusesPage.widgets.includes').toLowerCase() : ''}`
                };
                if (obj)
                    acc.push(obj);
                return acc;
            }, []);
        }
    },
    components: {
        BonusAccrualAccordion
    }
});
